export default __webpack_public_path__ + "static/media/appraise2.ccab5945.png";